import { Component, Input } from '@angular/core';

export type StatTrendTone = 'positive' | 'warning' | 'neutral';
export type StatValueTone = 'default' | 'warning';

export interface StatTrend {
  text: string;
  tone: StatTrendTone;
}

export interface Stat {
  value: number | string;
  label: string;
  trend?: StatTrend;
  valueTone?: StatValueTone;
}

@Component({
  selector: 'app-stat-strip-mock',
  templateUrl: './stat-strip-mock.component.html',
  styleUrls: ['./stat-strip-mock.component.scss']
})
export class StatStripMockComponent {
  @Input() stats: Stat[] = [
    { value: 28, label: 'Lessons Done',     trend: { text: '+3 this week',       tone: 'positive' } },
    { value: 14, label: 'Hrs Watched',      trend: { text: '+1.2 hrs this week', tone: 'positive' } },
    { value: 3,  label: 'Assignments Due',  trend: { text: '1 due in 2 days',    tone: 'warning' }, valueTone: 'warning' },
    { value: 2,  label: 'Active Courses',   trend: { text: '+1 in progress',     tone: 'positive' } },
  ];
}
